import styled from "styled-components";

const FooterSpan = styled.span`
    margin-right:0.5%;
`

export default FooterSpan;